export const generalConstitutional = (() => {
    const placeHolderText = 'No Recent weight loss, fevers or chills '

    return placeHolderText
})